import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface UserLeedflowStatsForPeriod {
  callsCount: number;
  callDurationMinutes: number;
  smsReceivedCount: number;
  smsSentCount: number;
}

export async function getUserStatsForPeriod(
  {
    userUid,
    startTimestamp,
    endTimestamp,
  }: {
    userUid: string;
    startTimestamp?: number;
    endTimestamp?: number;
  },
  companyApiKey: string,
  auth: Authentication,
): Promise<UserLeedflowStatsForPeriod> {
  try {
    const query = new URLSearchParams();
    if (startTimestamp !== undefined) query.set('start', String(startTimestamp));
    if (endTimestamp !== undefined) query.set('end', String(endTimestamp));

    const response = await HttpClient.get(
      `/leedflow/stats/user/${encodeURIComponent(userUid)}${query.toString() ? `?${query.toString()}` : ''}`,
      auth.token,
      {
        'x-api-key': companyApiKey,
      },
    );

    return (response?.data ?? {}) as UserLeedflowStatsForPeriod;
  } catch (e) {
    console.error('getUserStatsForPeriod error:', e);
    throw new GetUserStatsForPeriodFailure((e as Error)?.message || 'Unknown error');
  }
}

export class GetUserStatsForPeriodFailure extends Failure {
  constructor(message = 'Unknown error', code = 'get-user-stats-for-period-failure') {
    super(message, code);
  }
}

